export const REGISTER_CUSTOMER_REQUEST_START: string = 'register/customer/REQUEST_START';
export const REGISTER_CUSTOMER_REQUEST_FAIL: string = 'register/customer/REQUEST_FAIL';
export const REGISTER_CUSTOMER_REQUEST_SUCCESS: string = 'register/customer/REQUEST_SUCCESS';
export const UPDATE_REGISTER_CUSTOMER_STATUS_TO_INITIAL: string = 'register/customer/SET_INITIAL';
export const SEND_SKIP_DOCUMENT_EMAIL_START: string = 'register/send_email/skip_document/REQUEST_START';
export const SEND_SKIP_DOCUMENT_EMAIL_SUCCESS: string = 'register/send_email/skip_document/REQUEST_SUCCESS';
export const SEND_SKIP_DOCUMENT_EMAIL_FAIL: string = 'register/send_email/skip_document/REQUEST_FAIL';
